document.addEventListener('DOMContentLoaded', function() {

  const test = document.querySelectorAll('.linklist__links--level2 > .link > .link__anchor--has-star');
  
  if ( test ) {
  	const testArr = Array.from( test );
    let objCollections = {};  
    let objPackdeals = {};
    let count1 = 0;
    let count2 = 0;

    testArr.forEach( ( el, index, array ) => {
      let hanlde1 = 'element-' + count1;
      let hanlde2 = 'element-' + count2;
      let collections, packdeals;

      if ( el.innerHTML == 'Collections' ) {
          objCollections[hanlde1] = el;
      count1++;
          collections = el;
      } 
      if ( el.innerHTML == 'Pack Deals' ) {
        objPackdeals[hanlde2] = el;
      count2++
          packdeals = el;
      }
    } );

    if ( objCollections ) {
      for( const element in objCollections ) {
        if ( objPackdeals[element] ) { 
        	objCollections[element].parentNode.prepend( objPackdeals[element] );
        }
      }
    }    
  }
  
}, false);